import { NgModule } from "@angular/core";
import { NouisliderModule } from "ng2-nouislider";
import { SearchResultsComponent } from "apps-module/app/entry-modules/content-search/components/search-results/search-results.component";
import { ResultItemComponent } from "apps-module/app/entry-modules/content-search/components/search-results/result-item/result-item.component";
import { ContentSearchComponent } from "apps-module/app/entry-modules/content-search/content-search.component";
import { CommonComponentsModule } from "apps-module/app/common-components/common-components.module";
import { SearchMessageComponent } from "apps-module/app/entry-modules/content-search/components/search-message/search-message.component";

@NgModule({
    declarations: [
        SearchMessageComponent,
        ContentSearchComponent,
        ResultItemComponent,
        SearchResultsComponent
    ],
    exports: [ContentSearchComponent],
    imports: [
        CommonComponentsModule,
        NouisliderModule
    ]
})
export class ContentSearchModule { }
